import $ from 'jquery';

function scroll(element) {
    $('html, body').animate({
        scrollTop: $(element).offset().top
    }, 500);
}

$(document).ready(function() {
	$(document).on('click', '.js-anchor', function (event) {
	    event.preventDefault();
        scroll('#' + $(this).attr('data-anchor'));
	});
});


// WEBPACK FOOTER //
// ./src/js/general/anchor.js